import { Box, Stack, Typography } from '@mui/material';

import type {
  CalibrationMatrixDecisionEntry,
  CalibrationMatrixDecisions,
} from '@/api/types/calibrationMatrix.types';

interface CurrentDecisionsListProps {
  decisions: CalibrationMatrixDecisions;
}

const COLUMNS: { key: keyof CalibrationMatrixDecisions; title: string }[] = [
  { key: 'promote', title: 'Promote' },
  { key: 'holdAtGrade', title: 'Hold at Grade' },
  { key: 'checkIn', title: 'Check-in' },
];

function formatEntry(entry: CalibrationMatrixDecisionEntry): string {
  return `${entry.firstName} ${entry.lastName}${entry.geo ? ` (${entry.geo})` : ''}`;
}

export function CurrentDecisionsList({ decisions }: CurrentDecisionsListProps) {
  return (
    <Stack data-testid="decisions-list" spacing={3}>
      {COLUMNS.map(({ key, title }) => {
        const entries = decisions[key];
        return (
          <Box key={key} data-testid={`decisions-${key}`}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              {title}
            </Typography>
            {entries.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                (no consultants)
              </Typography>
            ) : (
              <Box
                component="ul"
                sx={{
                  pl: 0,
                  m: 0,
                  listStyle: 'none',
                  columnCount: { xs: 1, sm: 2, md: 3 },
                  columnGap: 3,
                }}
              >
                {entries.map((e) => (
                  <Typography
                    key={e.staffId}
                    component="li"
                    variant="body2"
                    sx={{ breakInside: 'avoid', mb: 0.5 }}
                  >
                    {formatEntry(e)}
                  </Typography>
                ))}
              </Box>
            )}
          </Box>
        );
      })}
    </Stack>
  );
}

export default CurrentDecisionsList;
